import * as Sentry from "@sentry/react";

// Substring -> fraction of events to keep. 0.0001 = 0.01% trickle keeps
// regressions detectable in Sentry without billing for steady-state noise.
const NOISY_ERROR_SAMPLE_RATES: Record<string, number> = {
  "Failed to fetch":                                  0.0001,
  "Authentication required - redirecting to sign in": 0.0001,
  "Token refresh failed - redirecting to sign in":    0.0001,
  "ResizeObserver loop":                              0.0001,
  "ChunkLoadError":                                   0.0001,
  "Loading chunk":                                    0.0001,
  "Loading CSS chunk":                                0.0001,
  "Non-Error promise rejection captured":             0.0001,
  "NetworkError when attempting to fetch":            0.0001,
  "Large HTTP Payload":                               0.01,
  "timeout":                                          0.05,
  "websocket error":                                  0.05,
  "xhr poll error":                                   0.05,
};

function shouldKeep(text: string): boolean {
  for (const [needle, rate] of Object.entries(NOISY_ERROR_SAMPLE_RATES)) {
    if (text.includes(needle)) return Math.random() < rate;
  }
  return true;
}

function stripSensitiveRequestData(event: Sentry.Event) {
  if (event.request?.cookies) delete event.request.cookies;
  if (event.request?.headers?.authorization) delete event.request.headers.authorization;
  if (event.request?.headers?.Authorization) delete event.request.headers.Authorization;
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enableLogs: true,
  integrations: [
    Sentry.breadcrumbsIntegration({
      console: false,
      dom: true,
      fetch: true,
      xhr: true,
    }),
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    /^\//,
    /^https:\/\/.*api\.hourglass\.law/,
    /^https:\/\/hourglassapi\./,
  ],
  denyUrls: [/localhost/, /127\.0\.0\.1/],
  initialScope: {
    tags: { law_firm_host: window.location.hostname },
  },
  beforeSend(event) {
    stripSensitiveRequestData(event);
    const text = event.exception?.values?.[0]?.value ?? event.message ?? "";
    return shouldKeep(text) ? event : null;
  },
  beforeSendTransaction(event) {
    stripSensitiveRequestData(event);
    return event;
  },
});
